export const ValidatorErrorKeys = {
  invalidEmail: 'validationErrors:invalidEmail',
  invalidNumber: 'validationErrors:invalidNumber',
  invalidField: 'validationErrors:invalidField',
  invalidDate: 'validationErrors:invalidDate',
  minLengthNotRespected: 'validationErrors:minLengthNotRespected',
  nameDuplicate: 'validationErrors:nameDuplicate',
  nameCannotBeKeyword: 'validationErrors:nameCannotBeKeyword',
  nameInvalid: 'validationErrors:nameInvalid',
  nameRequired: 'validationErrors:nameRequired',

  aggregateFunction: {
    expressionRequired: 'validationErrors:aggregateFunction.expressionRequired',
  },

  analysis: {
    labelDefaultLangRequired: 'validationErrors:analysis.labelDefaultLangRequired',
    analysisNodeDefsRequired: 'validationErrors:analysis.analysisNodeDefsRequired',
  },

  categoryEdit: {
    childrenEmpty: 'validationErrors:categoryEdit.childrenEmpty',
    childrenInvalid: 'validationErrors:categoryEdit.childrenInvalid',
    codeCannotBeKeyword: 'validationErrors:categoryEdit.codeCannotBeKeyword',
    codeDuplicate: 'validationErrors:categoryEdit.codeDuplicate',
    codeRequired: 'validationErrors:categoryEdit.codeRequired',
    itemExtraPropDataTypeRequired: 'validationErrors:categoryEdit.itemExtraPropDataTypeRequired',
    itemExtraPropNameInvalid: 'validationErrors:categoryEdit.itemExtraPropNameInvalid',
    itemExtraPropInvalidNumber: 'validationErrors:categoryEdit.itemExtraPropInvalidNumber',
    itemExtraPropInvalidGeometryPoint: 'validationErrors:categoryEdit.itemExtraPropInvalidGeometryPoint',
    itemsInvalid: 'validationErrors:categoryEdit.itemsInvalid',
    itemsEmpty: 'validationErrors:categoryEdit.itemsEmpty',
    levelDuplicate: 'validationErrors:categoryEdit.levelDuplicate',
    levelsInvalid: 'validationErrors:categoryEdit.levelsInvalid',
  },

  categoryImport: {
    cannotDeleteLevelsOfPublishedCategory: 'validationErrors:categoryImport.cannotDeleteLevelsOfPublishedCategory',
    cannotDeleteItemsOfPublishedCategory: 'validationErrors:categoryImport.cannotDeleteItemsOfPublishedCategory',
    codeColumnMissing: 'validationErrors:categoryImport.codeColumnMissing',
    codeDuplicate: 'validationErrors:categoryImport.codeDuplicate',
    codeRequired: 'validationErrors:categoryImport.codeRequired',
    columnMissing: 'validationErrors:categoryImport.columnMissing',
    emptyHeaderFound: 'validationErrors:categoryImport.emptyHeaderFound',
    emptyFile: 'validationErrors:categoryImport.emptyFile',
    invalidParentItemOrder: 'validationErrors:categoryImport.invalidParentItemOrder',
    nameDuplicate: 'validationErrors:categoryImport.nameDuplicate',
    srsNotDefined: 'validationErrors:categoryImport.srsNotDefined',
  },

  dataImport: {
    recordInAnalysisStepCannotBeUpdated: 'validationErrors:dataImport.recordInAnalysisStepCannotBeUpdated',
    emptyFile: 'validationErrors:dataImport.emptyFile',
    errorUpdatingValues: 'validationErrors:dataImport.errorUpdatingValues',
    multipleRecordsMatchingKeys: 'validationErrors:dataImport.multipleRecordsMatchingKeys',
    recordAlreadyExisting: 'validationErrors:dataImport.recordAlreadyExisting',
    recordKeyMissingOrInvalid: 'validationErrors:dataImport.recordKeyMissingOrInvalid',
    recordNotFound: 'validationErrors:dataImport.recordNotFound',
  },

  expressions: {
    cannotGetChildOfAttribute: 'validationErrors:expressions.cannotGetChildOfAttribute',
    cannotUseCurrentNode: 'validationErrors:expressions.cannotUseCurrentNode',
    circularDependencyError: 'validationErrors:expressions.circularDependencyError',
    expressionInvalid: 'validationErrors:expressions.expressionInvalid',
    unableToFindNode: 'validationErrors:expressions.unableToFindNode',
    unableToFindNodeChild: 'validationErrors:expressions.unableToFindNodeChild',
    unableToFindNodeParent: 'validationErrors:expressions.unableToFindNodeParent',
    unableToFindNodeSibling: 'validationErrors:expressions.unableToFindNodeSibling',
  },

  extraPropEdit: {
    dataTypeRequired: 'validationErrors:extraPropEdit.dataTypeRequired',
    nameInvalid: 'validationErrors:extraPropEdit.nameInvalid',
    nameRequired: 'validationErrors:extraPropEdit.nameRequired',
    valueRequired: 'validationErrors:extraPropEdit.valueRequired',
  },

  message: {
    bodyRequired: 'validationErrors:message.bodyRequired',
    notificationTypeRequired: 'validationErrors:message.notificationTypeRequired',
    subjectRequired: 'validationErrors:message.subjectRequired',
    targetsRequired: 'validationErrors:message.targetsRequired',
  },

  nodeDefEdit: {
    analysisParentEntityRequired: 'validationErrors:nodeDefEdit.analysisParentEntityRequired',
    applyIfDuplicate: 'validationErrors:nodeDefEdit.applyIfDuplicate',
    applyIfInvalid: 'validationErrors:nodeDefEdit.applyIfInvalid',
    categoryRequired: 'validationErrors:nodeDefEdit.categoryRequired',
    childrenEmpty: 'validationErrors:nodeDefEdit.childrenEmpty',
    columnWidthCannotBeGreaterThan: 'validationErrors:nodeDefEdit.columnWidthCannotBeGreaterThan',
    columnWidthCannotBeLessThan: 'validationErrors:nodeDefEdit.columnWidthCannotBeLessThan',
    countMaxInvalid: 'validationErrors:nodeDefEdit.countMaxInvalid',
    countMaxMustBePositiveNumber: 'validationErrors:nodeDefEdit.countMaxMustBePositiveNumber',
    countMinInvalid: 'validationErrors:nodeDefEdit.countMinInvalid',
    countMinMustBePositiveNumber: 'validationErrors:nodeDefEdit.countMinMustBePositiveNumber',
    defaultValuesInvalid: 'validationErrors:nodeDefEdit.defaultValuesInvalid',
    defaultValuesNotSpecified: 'validationErrors:nodeDefEdit.defaultValuesNotSpecified',
    entitySourceRequired: 'validationErrors:nodeDefEdit.entitySourceRequired',
    expressionApplyIfOnlyLastOneCanBeEmpty: 'validationErrors:nodeDefEdit.expressionApplyIfOnlyLastOneCanBeEmpty',
    expressionDuplicate: 'validationErrors:nodeDefEdit.expressionDuplicate',
    expressionRequired: 'validationErrors:nodeDefEdit.expressionRequired',
    formulaInvalid: 'validationErrors:nodeDefEdit.formulaInvalid',
    keysEmpty: 'validationErrors:nodeDefEdit.keysEmpty',
    keysExceedingMax: 'validationErrors:nodeDefEdit.keysExceedingMax',
    maxFileSizeInvalid: 'validationErrors:nodeDefEdit.maxFileSizeInvalid',
    nameInvalid: 'validationErrors:nodeDefEdit.nameInvalid',
    qualifierCannotHaveApplicableExpression: 'validationErrors:nodeDefEdit.qualifierCannotHaveApplicableExpression',
    qualifierCannotHaveDefaultValues: 'validationErrors:nodeDefEdit.qualifierCannotHaveDefaultValues',
    qualifierCannotHaveEditabilityRule: 'validationErrors:nodeDefEdit.qualifierCannotHaveEditabilityRule',
    qualifierCannotHaveValidations: 'validationErrors:nodeDefEdit.qualifierCannotHaveValidations',
    readOnlyCannotHaveEditableIf: 'validationErrors:nodeDefEdit.readOnlyCannotHaveEditableIf',
    requiredIfInvalid: 'validationErrors:nodeDefEdit.requiredIfInvalid',
    requiredIfNotAllowed: 'validationErrors:nodeDefEdit.requiredIfNotAllowed',
    taxonomyRequired: 'validationErrors:nodeDefEdit.taxonomyRequired',
    validationsInvalid: 'validationErrors:nodeDefEdit.validationsInvalid',
  },

  record: {
    keyDuplicate: 'validationErrors:record.keyDuplicate',
    oneOrMoreInvalidValues: 'validationErrors:record.oneOrMoreInvalidValues',
    uniqueAttributeDuplicate: 'validationErrors:record.uniqueAttributeDuplicate',
    valueRequired: 'validationErrors:record.valueRequired',
  },

  surveyInfoEdit: {
    langRequired: 'validationErrors:surveyInfoEdit.langRequired',
    srsRequired: 'validationErrors:surveyInfoEdit.srsRequired',
    cycleRequired: 'validationErrors:surveyInfoEdit.cycleRequired',
    cyclesRequired: 'validationErrors:surveyInfoEdit.cyclesRequired',
    cyclesExceedingMax: 'validationErrors:surveyInfoEdit.cyclesExceedingMax',
    cycleDateStartMandatory: 'validationErrors:surveyInfoEdit.cycleDateStartMandatory',
    cycleDateStartInvalid: 'validationErrors:surveyInfoEdit.cycleDateStartInvalid',
    cycleDateStartBeforeDateEnd: 'validationErrors:surveyInfoEdit.cycleDateStartBeforeDateEnd',
    cycleDateEndInvalid: 'validationErrors:surveyInfoEdit.cycleDateEndInvalid',
    cycleDateEndMandatoryExceptForLastCycle: 'validationErrors:surveyInfoEdit.cycleDateEndMandatoryExceptForLastCycle',
    cycleDateStartAfterPrevDateEnd: 'validationErrors:surveyInfoEdit.cycleDateStartAfterPrevDateEnd',
    fieldManualLinksInvalid: 'validationErrors:surveyInfoEdit.fieldManualLinksInvalid',
  },

  surveyPreloadedMapLayer: {
    fileRequired: 'validationErrors:surveyPreloadedMapLayer.fileRequired',
    fileNameDuplicate: 'validationErrors:surveyPreloadedMapLayer.fileNameDuplicate',
    labelsRequired: 'validationErrors:surveyPreloadedMapLayer.labelsRequired',
  },

  surveyDocImage: {
    documentPlaceRequired: 'validationErrors:surveyDocImage.documentPlaceRequired',
    fileRequired: 'validationErrors:surveyDocImage.fileRequired',
    fileNameDuplicate: 'validationErrors:surveyDocImage.fileNameDuplicate',
    labelsRequired: 'validationErrors:surveyDocImage.labelsRequired',
  },

  taxonomyEdit: {
    codeChangedAfterPublishing: 'validationErrors:taxonomyEdit.codeChangedAfterPublishing',
    codeDuplicate: 'validationErrors:taxonomyEdit.codeDuplicate',
    codeRequired: 'validationErrors:taxonomyEdit.codeRequired',
    familyRequired: 'validationErrors:taxonomyEdit.familyRequired',
    genusRequired: 'validationErrors:taxonomyEdit.genusRequired',
    scientificNameDuplicate: 'validationErrors:taxonomyEdit.scientificNameDuplicate',
    scientificNameRequired: 'validationErrors:taxonomyEdit.scientificNameRequired',
    taxaEmpty: 'validationErrors:taxonomyEdit.taxaEmpty',
    vernacularNamesDuplicate: 'validationErrors:taxonomyEdit.vernacularNamesDuplicate',
  },

  taxonomyImportJob: {
    duplicateExtraPropsColumns: 'validationErrors:taxonomyImportJob.duplicateExtraPropsColumns',
    invalidExtraPropColumn: 'validationErrors:taxonomyImportJob.invalidExtraPropColumn',
    missingRequiredColumns: 'validationErrors:taxonomyImportJob.missingRequiredColumns',
  },

  user: {
    emailDuplicate: 'validationErrors:user.emailDuplicate',
    emailInvalid: 'validationErrors:user.emailInvalid',
    emailRequired: 'validationErrors:user.emailRequired',
    emailNotFound: 'validationErrors:user.emailNotFound',
    groupRequired: 'validationErrors:user.groupRequired',
    nameRequired: 'validationErrors:user.nameRequired',
    titleRequired: 'validationErrors:user.titleRequired',
    passwordRequired: 'validationErrors:user.passwordRequired',
    passwordInvalid: 'validationErrors:user.passwordInvalid',
    passwordUnsafe: 'validationErrors:user.passwordUnsafe',
    passwordsDoNotMatch: 'validationErrors:user.passwordsDoNotMatch',

    userNotFound: 'validationErrors:user.userNotFound',
    passwordChangeRequired: 'validationErrors:user.passwordChangeRequired',
    passwordResetNotAllowedWithPendingInvitation: 'validationErrors:user.passwordResetNotAllowedWithPendingInvitation',
    twoFactorTokenRequired: 'validationErrors:user.twoFactorTokenRequired',
  },

  userAccessRequest: {
    countryRequired: 'validationErrors:userAccessRequest.countryRequired',
    emailRequired: 'validationErrors:userAccessRequest.emailRequired',
    emailInvalid: 'validationErrors:userAccessRequest.emailInvalid',
    firstNameRequired: 'validationErrors:userAccessRequest.firstNameRequired',
    institutionRequired: 'validationErrors:userAccessRequest.institutionRequired',
    lastNameRequired: 'validationErrors:userAccessRequest.lastNameRequired',
    purposeRequired: 'validationErrors:userAccessRequest.purposeRequired',
    surveyNameRequired: 'validationErrors:userAccessRequest.surveyNameRequired',
  },

  userAccessRequestAccept: {
    accessRequestAlreadyProcessed: 'validationErrors:userAccessRequestAccept.accessRequestAlreadyProcessed',
    accessRequestNotFound: 'validationErrors:userAccessRequestAccept.accessRequestNotFound',
    emailRequired: 'validationErrors:userAccessRequestAccept.emailRequired',
    emailInvalid: 'validationErrors:userAccessRequestAccept.emailInvalid',
    roleRequired: 'validationErrors:userAccessRequestAccept.roleRequired',
    surveyNameRequired: 'validationErrors:userAccessRequestAccept.surveyNameRequired',
  },

  userGroupEdit: {
    nameDuplicate: 'validationErrors:userGroupEdit.nameDuplicate',
    qualifiersInvalid: 'validationErrors:userGroupEdit.qualifiersInvalid',
    qualifierNameDuplicate: 'validationErrors:userGroupEdit.qualifierNameDuplicate',
    qualifierNameInvalid: 'validationErrors:userGroupEdit.qualifierNameInvalid',
    qualifierNameRequired: 'validationErrors:userGroupEdit.qualifierNameRequired',
  },

  userPasswordChange: {
    oldPasswordRequired: 'validationErrors:userPasswordChange.oldPasswordRequired',
    oldPasswordWrong: 'validationErrors:userPasswordChange.oldPasswordWrong',
    newPasswordRequired: 'validationErrors:userPasswordChange.newPasswordRequired',
    confirmPasswordRequired: 'validationErrors:userPasswordChange.confirmPasswordRequired',
    confirmedPasswordNotMatching: 'validationErrors:userPasswordChange.confirmedPasswordNotMatching',
  },

  userInvite: {
    messageContainsLinks: 'validationErrors:userInvite.messageContainsLinks',
    messageTooLong: 'validationErrors:userInvite.messageTooLong',
  },

  user2FADevice: {
    nameDuplicate: 'validationErrors:user2FADevice.nameDuplicate',
    nameRequired: 'validationErrors:user2FADevice.nameRequired',
  },
}
